import { DatePicker } from 'antd';
import type { CreatedRange } from './created-range';

type Props = {
  value: CreatedRange;
  onChange: (range: CreatedRange) => void;
};

export const CreatedRangeFilter = ({ value, onChange }: Props) => (
  <DatePicker.RangePicker
    value={value}
    onChange={(range) => onChange(range as CreatedRange)}
    allowEmpty={[true, true]}
    placeholder={['Created from', 'to']}
  />
);
